import { compose, withHandlers } from 'recompose';
import { addIntlProps, addProps } from 'utils/recompose';
import { injectIntl } from 'react-intl';
import messages from './messages';
import { orderDashboardPath } from 'utils/paths';

export const submissionConfirmation = ({
  unit,
  units,
  requestSubmittedString,
  history,
}) => {
  const quantity = history.location.state.quantity;
  const unitString = quantity > 1 ? units : unit;
  return `${requestSubmittedString} ${quantity} ${unitString}!`;
};

export const goToDashboard = ({ history }) => () => {
  history.push(orderDashboardPath);
};

export default compose(
  injectIntl,
  addIntlProps({
    messages,
    propNames: [
      'unit',
      'units',
      'requestSubmittedString',
      'darUpdateString',
      'backToDashboardString',
    ],
  }),
  addProps({
    submissionConfirmation,
  }),
  withHandlers({ goToDashboard }),
);
